import { createContext } from "react";
var CarrierLogisticsCommonsDispatchContext = createContext({
    localisationDispatch: null
});
export default CarrierLogisticsCommonsDispatchContext;

//# sourceMappingURL=CarrierLogisticsCommonsDispatchContext.js.map